import React from 'react';
import { Button } from 'reactstrap';
import { AvatarPreview, StatusBadge } from '../../components/Common';
import { MEMBER_STATUS } from "../../constants/members";

// Lista de abas de filtro para a página de clientes
export const MEMBER_STATUS_TABS = [
    { label: 'Todos', value: 'all' },
    { label: 'Ativos', value: MEMBER_STATUS.ACTIVE },
    { label: 'Prospect', value: MEMBER_STATUS.LEAD },
    { label: 'Inativos', value: MEMBER_STATUS.INACTIVE },
    { label: 'Suspensos', value: MEMBER_STATUS.SUSPENDED },
];

/**
 * Retorna as colunas da tabela de clientes
 * @param {function} navigate Função de navegação (react-router-dom)
 * @returns {Array} Array de configuração de colunas para o DataTable
 */
export const getMembersColumns = (navigate) => [
    {
        key: 'photoUrl',
        label: '',
        style: { width: '50px' },
        render: (row) => (
            <AvatarPreview
                src={row.photoUrl}
                alt={row.fullName}
                size="xs"
                className="rounded-circle shadow-sm"
                fallbackType="icon"
            />
        )
    },
    {
        key: 'fullName',
        label: 'Nome / ID / E-mail',
        render: (row) => (
            <div className="d-flex flex-column">
                <span className="fw-bold text-dark font-size-14 mb-0">{row.fullName}</span>
                <div className="d-flex align-items-center gap-2">
                    <small className="text-primary fw-bold font-size-10">ID: {row.memberNumber || "----"}</small>
                    <small className="text-muted font-size-11">{row.email || "Sem e-mail"}</small>
                </div>
            </div>
        )
    },
    {
        key: 'phone',
        label: 'Telefone',
        render: (row) => (
            <span className="text-muted font-size-13">
                <i className="mdi mdi-phone-outline me-1 text-primary"></i>
                {row.phone || "(00) 00000-0000"}
            </span>
        )
    },
    {
        key: "activities",
        label: "Atividades",
        render: (row) => (
            <div className="d-flex flex-wrap gap-1">
                {row.activityNames && row.activityNames.length > 0 ? (
                    row.activityNames.slice(0, 2).map((name, idx) => (
                        <span key={idx} className="badge bg-light text-dark border font-size-10 px-2 py-1">
                            {name}
                        </span>
                    ))
                ) : (
                    <small className="text-muted fst-italic">Nenhuma</small>
                )}
                {row.activityNames?.length > 2 && (
                    <span className="badge bg-light text-primary border font-size-10">+{row.activityNames.length - 2}</span>
                )}
            </div>
        )
    },
    {
        key: 'status',
        label: 'Status',
        style: { width: '120px' },
        render: (row) => <StatusBadge status={row.status} />
    },
    {
        key: 'actions',
        label: 'Ações',
        style: { width: '120px' },
        headerClassName: 'text-end',
        className: 'text-end',
        render: (row) => (
            <div className="d-flex justify-content-end">
                <Button
                    color="primary"
                    size="sm"
                    className="btn-soft-info border-0 rounded-0"
                    title="Ver Perfil"
                    onClick={() => navigate(`/members/${row.id}`)}
                >
                    <i className="mdi mdi-eye-outline font-size-14"></i>
                </Button>
            </div>
        )
    }
];
